import { Discount } from '@squareup/sq-addons-web-sdk';
export interface DiscountsState {
  availableDiscounts: Discount[];
  appliedDiscounts: Discount[];
  unavailableDiscounts: string[];
  updatedDiscounts: Discount[];
  fetchDiscountsState: {
    success?: boolean;
    isPending: boolean;
    error?: Error;
  };
  addDiscountState: {
    isPending: boolean;
    error?: Error;
  };
  removeDiscountState: {
    isPending: boolean;
    error?: Error;
  };
  removeDiscountsState: {
    isPending: boolean;
    success?: boolean;
    error?: Error;
  };
  clearDiscountsState: {
    isPending: boolean;
    error?: Error;
  };
}

export const ADD_DISCOUNT = 'ADD_DISCOUNT';
export const ADD_DISCOUNT_FULFILLED = 'ADD_DISCOUNT_FULFILLED';
export const ADD_DISCOUNT_REJECTED = 'ADD_DISCOUNT_REJECTED';

export const CLEAR_DISCOUNTS = 'CLEAR_DISCOUNTS';
export const CLEAR_DISCOUNTS_FULFILLED = 'CLEAR_DISCOUNTS_FULFILLED';
export const CLEAR_DISCOUNTS_REJECTED = 'CLEAR_DISCOUNTS_REJECTED';

export const FETCH_DISCOUNTS = 'FETCH_DISCOUNTS';
export const FETCH_DISCOUNTS_FULFILLED = 'FETCH_DISCOUNTS_FULFILLED';
export const FETCH_DISCOUNTS_REJECTED = 'FETCH_DISCOUNTS_REJECTED';

export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT';
export const REMOVE_DISCOUNT_FULFILLED = 'REMOVE_DISCOUNT_FULFILLED';
export const REMOVE_DISCOUNT_REJECTED = 'REMOVE_DISCOUNT_REJECTED';

export const REMOVE_DISCOUNTS = 'REMOVE_DISCOUNTS';
export const REMOVE_DISCOUNTS_FULFILLED = 'REMOVE_DISCOUNTS_FULFILLED';
export const REMOVE_DISCOUNTS_REJECTED = 'REMOVE_DISCOUNTS_REJECTED';
export const RESET_REMOVE_DISCOUNTS = 'RESET_REMOVE_DISCOUNTS';

export const RESET_DISCOUNTS = 'RESET_DISCOUNTS';

export const SUBMIT_DISCOUNTS = 'SUBMIT_DISCOUNT';
export const SUBMIT_DISCOUNTS_FULFILLED = 'SUBMIT_DISCOUNT_FULFILLED';
export const SUBMIT_DISCOUNTS_REJECTED = 'SUBMIT_DISCOUNT_REJECTED';

export type AddDiscountAction = {
  type: typeof ADD_DISCOUNT;
  payload: {
    discount: Discount;
  };
};

export type AddDiscountFulfilledAction = {
  type: typeof ADD_DISCOUNT_FULFILLED;
};

export type AddDiscountRejectedAction = {
  type: typeof ADD_DISCOUNT_REJECTED;
  payload: {
    error: Error;
  };
};

export type ClearDiscountsAction = {
  type: typeof CLEAR_DISCOUNTS;
};

export type ClearDiscountsFulfilledAction = {
  type: typeof CLEAR_DISCOUNTS_FULFILLED;
};

export type ClearDiscountsRejectedAction = {
  type: typeof CLEAR_DISCOUNTS_REJECTED;
  payload: {
    error: Error;
  };
};

export type FetchDiscountsAction = {
  type: typeof FETCH_DISCOUNTS;
};

export type FetchDiscountsFulfilledAction = {
  type: typeof FETCH_DISCOUNTS_FULFILLED;
  payload: {
    availableDiscounts: Discount[];
    appliedDiscounts: Discount[];
    unavailableDiscounts: string[];
    updatedDiscounts: Discount[];
  };
};

export type FetchDiscountsRejectedAction = {
  type: typeof FETCH_DISCOUNTS_REJECTED;
  payload: {
    error: Error;
  };
};

export type RemoveDiscountAction = {
  type: typeof REMOVE_DISCOUNT;
  payload: {
    discount: Discount;
  };
};

export type RemoveDiscountFulfilledAction = {
  type: typeof REMOVE_DISCOUNT_FULFILLED;
};

export type RemoveDiscountRejectedAction = {
  type: typeof REMOVE_DISCOUNT_REJECTED;
  payload: {
    error: Error;
  };
};

export type RemoveDiscountsAction = {
  type: typeof REMOVE_DISCOUNTS;
  payload: {
    discountIds: string[];
  };
};

export type RemoveDiscountsFulfilledAction = {
  type: typeof REMOVE_DISCOUNTS_FULFILLED;
};

export type RemoveDiscountsRejectedAction = {
  type: typeof REMOVE_DISCOUNTS_REJECTED;
  payload: {
    error: Error;
  };
};

export type ResetRemoveDiscountsAction = {
  type: typeof RESET_REMOVE_DISCOUNTS;
};

export type ResetDiscountsAction = {
  type: typeof RESET_DISCOUNTS;
};

export type DiscountsActionTypes =
  | AddDiscountAction
  | AddDiscountFulfilledAction
  | AddDiscountRejectedAction
  | ClearDiscountsAction
  | ClearDiscountsFulfilledAction
  | ClearDiscountsRejectedAction
  | FetchDiscountsAction
  | FetchDiscountsFulfilledAction
  | FetchDiscountsRejectedAction
  | RemoveDiscountAction
  | RemoveDiscountFulfilledAction
  | RemoveDiscountRejectedAction
  | RemoveDiscountsAction
  | RemoveDiscountsFulfilledAction
  | RemoveDiscountsRejectedAction
  | ResetRemoveDiscountsAction
  | ResetDiscountsAction;
